import React from 'react';
import { Table } from 'react-bootstrap';

const DynamicTable = ({ data }) => {

  if (!data) {
    return null;
  }

  const titles = {
    "nameStore": ["Store Name", ""],
    "pathStore": ["Path", ""],
    "_id": ["Id", ""],
    "totalSales": ["Total Sales", "$"],
    "totalOrders": ["Total Orders", ""],
    "totalProducts": ["Total Products", ""],
    "ticketAverage": ["Ticket Average", "$"],
    "t1PaginasCommission": ["T1 Paginas Commission", "$"],
    "rateT1PaginasCommission": ["Rate T1 Paginas Commission", "%"],
    "t1PagosCommission": ["T1 Pagos Commmission", "$"],
    "rateT1PagosCommission": ["Rate T1 Pagos Commmission", "%"],
    "totalIncomeCommission": ["Total Income Commission", "$"],
    "rateTotalIncomeCommission": ["Rate Total Income Commission", "%"],
    "totalStores": ["Stores", ""],
  };

  return (
    <Table size="sm" striped bordered hover style={{ borderColor: 'lightblue' }}>
      <thead>
        <tr>
          <th>Concept</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(data).map((key) => (
          <tr key={key}>
            <td>{titles[key][0]}</td>
            <td>
              {titles[key][1] === "$" || titles[key][1] === "%" ? (
                `${titles[key][1]} ${data[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
              ) : (
                data[key]
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DynamicTable;